import { ScrollbarThemeDirective } from './../../directives/scroll-directive/scrollbar-theme.directive';
import { Router, ActivatedRoute } from '@angular/router';
import { BasePage } from './../base.page';
import { Component, OnInit } from '@angular/core';
import { UserModel } from 'src/app/models/user.model';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import {
  Platform,
  LoadingController,
  ToastController,
  ModalController,
  ActionSheetController,
} from '@ionic/angular';
import { HamburgerMenuComponent } from 'src/app/components/hamburger-menu/hamburger-menu.component';
import { UserFriendsModalComponent } from './../../components/user-friends-modal/user-friends-modal.component';
import { SubscribeNowModalComponent } from 'src/app/components/subscribe-now-modal/subscribe-now-modal.component';
import { ImageViewerComponent } from 'src/app/components/image-viewer/image-viewer.component';
import { BuyerShippingAddressPaymentComponent } from 'src/app/components/buyer-shipping-address-payment/buyer-shipping-address-payment.component';
import { environment } from 'src/environments/environment';
// import { Subscription } from 'rxjs';

@Component({
  selector: 'shc-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage extends BasePage implements OnInit {
  userDetail: UserModel;
  modalController: any;
  useer = this.userService.userData;
  // userSubscription: Subscription;  // <-- Declare here
  userId: number; // <-- Initialize to null

  averageRating: number = 0;
  msg: boolean = false;
  Math = Math;
  isDev = !environment.production;

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private router: Router,
    private route: ActivatedRoute,
    private modalCtrl: ModalController,
    private actionCtrl: ActionSheetController,
  ) {
    super(
      platform,
      userService,
      authService,
      translate,
      loadingCtrl,
      toastController,
      null,
      actionCtrl,
    );

    this.route.params.subscribe((res) => {
      this.userService.getUpdatedUser().subscribe(
        (res) => {
          this.userDetail = res;
          // this.user$.next(res);
          this.userService.updatedUser.next(res);
        },
        (error) => {
          this.errorService.handle(error);
        },
      );
    });
  }

  ngOnInit() {
      // this.userSubscription = this.userService.userData.subscribe(user => {
      //   if (user) {
      //     this.userId = user.id;  // <-- here you get the user ID
      //     console.log('profile page User ID:', this.userId);
      //   } else {
      //     this.userId = null;
      //   }
      //   this.goToRatingList(this.userId);
      // });
      this.userService.getLoggedInUserId().subscribe({
        next: (userId) => {
          this.userService.getUserRatings(userId).subscribe({
            next: (response) => {
            this.averageRating = response.average_rating;
            if (this.averageRating === 0) {
              this.msg = true;
            }
          },
            error: (err) => {
              console.error('Error fetching rating:', err);
            }
          });
        },
        error: (err) => {
          console.error('Error getting user ID:', err);
        }
      });
  }

  ionViewWillEnter() {}

  async openUsers(type: string) {
    const modal = await this.modalCtrl.create({
      component: UserFriendsModalComponent,
      componentProps: { type },
      cssClass: 'following',
      id: 'userFriends',
      mode: 'md',
      keyboardClose: true,
      backdropDismiss: true,
      canDismiss: true,
      // initialBreakpoint: 0.9
    });
    modal.onDidDismiss().then((data) => {
      // manage the data after the UserFriendsModalComponent modal is closed
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  async userFollowers(type: string) {
    const modal = await this.modalCtrl.create({
      component: UserFriendsModalComponent,
      componentProps: { type },
      cssClass: 'following',
      id: 'userFriends',
      mode: 'md',
      keyboardClose: true,
      backdropDismiss: true,
      canDismiss: true,
      // initialBreakpoint: 0.9,
    });
    modal.onDidDismiss().then((data) => {
      // manage the data after the UserFriendsModalComponent modal is closed
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  async subscribeNow() {
    const modal = await this.modalCtrl.create({
      component: SubscribeNowModalComponent,
      cssClass: 'subscribeNow',
      id: 'subscribeNow',
      keyboardClose: true,
      mode: 'md',
      backdropDismiss: true,
      canDismiss: true,
    });
    modal.onDidDismiss().then((data) => {
      // manage the data after the SubscribeNowModalComponent modal is closed
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  async openMenu() {
    const modal = await this.modalCtrl.create({
      component: HamburgerMenuComponent,
      cssClass: 'hamBurgermenu',
      canDismiss: true,
      id: 'hamBurgermenu',
      // initialBreakpoint: 0.9,
    });
    modal.onDidDismiss().then((data) => {
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  navigateToWardrobe() {
    this.router.navigate(['wardrobe']);
  }

  navigateToEditProfile() {
    this.router.navigate(['update-profile']);
  }

  async openDevShippingTest() {
    const modal = await this.modalCtrl.create({
      component: BuyerShippingAddressPaymentComponent,
      componentProps: {
        userId: this.userDetail?.id,
        productId: 1536,
        chatId: 'dev-test',
        userType: 'buying',
        formSubmittedSuccessfully: false,
      },
    });
    return await modal.present();
  }

  async showImageModal(url: string) {
    console.log(url);
    
    if (!url) {
      return;
    }

    const modal = await this.modalCtrl.create({
      component: ImageViewerComponent,
      componentProps: {
        image: url
      },
    });

    return await modal.present();
  }

}
